import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { MOBILE_BREAKPOINT } from "../../styles/responsive";

interface Props {
  items: Array<[string, ReactNode]>;
}

/** ラベルと値の一覧（定義リスト）。SP は 1 列、PC はラベル列＋値列。 */
export const FieldList: React.FC<Props> = ({ items }) => (
  <Box
    component="dl"
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", [MOBILE_BREAKPOINT]: "180px 1fr" },
      gap: { xs: 1, [MOBILE_BREAKPOINT]: 2 },
      m: 0,
    }}
  >
    {items.map(([label, value]) => (
      <Box key={label} sx={{ display: "contents" }}>
        <Typography component="dt" color="text.secondary">
          {label}
        </Typography>
        <Typography component="dd" sx={{ m: 0, overflowWrap: "anywhere" }}>
          {value ?? "—"}
        </Typography>
      </Box>
    ))}
  </Box>
);
